import { Box, Button, CircularProgress, Icon, Link, Paper, Stack, Typography } from "@mui/material"
import { toastError } from "../../redux/guest-slices/other.slice"
import { forgotPasswordReq } from "../../redux/admin-slices/auth.slice"
import InputFieldA from "../../components/ui/InputFieldA"
import { useDispatch, useSelector } from "react-redux"
import { Link as NavLink } from "react-router-dom"
import Icons from "../../assets/js/Icons"

function ForgotPassword() {
  const dispatch = useDispatch()
  const { other } = useSelector(state => state.authSlice)

  // Handle user signup 
  const handleSubmit = (e) => {
    e.preventDefault()
    const form = new FormData(e.target)
    const formData = Object.fromEntries(form)
    if (
      Object.keys(formData)?.some((field) => {
        const value = formData[field]
        return (value?.trim() === "" || !value)
      })
    ) {
      return dispatch(toastError("Please fill all required field!"))
    }
    dispatch(forgotPasswordReq(formData))
      .unwrap()
      .then(() => {
        e.target.reset()
      })
      .catch(() => {})
  }

  return (
    <Box
      sx={{
        display: "grid",
        minHeight: "100vh",
        alignItems: "center",
      }}
    >
      <Paper
        sx={{
          p: 3,
          mx: "auto",
          width: "100%",
          display: "block",
          maxWidth: "450px",
          boxShadow: "0 0 40px 0 #0000001a",
        }}
        component="form"
        onSubmit={handleSubmit}
      >
        <Typography
          mb={3}
          fontSize={24}
          fontWeight="700"
          textAlign="center"
        >Forgot Password
        </Typography>

        <Stack spacing={3}>
          <Box>
            <InputFieldA
              type="email"
              name="email"
              label="Email"
              placeholder="Email Address"
              startIcon={
                <Icon sx={{ fontSize: "20px", color: "other.color1", mr: 0.5 }}>
                  <Icons.MailSolid />
                </Icon>
              }
            />
            <Typography
              mt={1}
              fontSize={14}
              textAlign="end"
              color="other.color1"
            >
              <Link
                underline="hover"
                component={NavLink}
                to="/login"
              >Back to login?
              </Link>
            </Typography>
          </Box>
          <Button
            sx={{
              p: "9px 17px",
              lineHeight: "1.5",
              fontSize: "18px",
              justifyContent: "center",
            }}
            type="submit"
            variant="contained"
            endIcon={
              other?.loadingLogin &&
              <CircularProgress
                size={22}
                color="text"
                thickness={6}
              />
            }
          >Send Email
          </Button>
        </Stack>
      </Paper>
    </Box >
  )
}

export default ForgotPassword